import * as t from 'io-ts';

export const zendeskRequester = t.type({
  email: t.string,
});

export const zendeskTicket = t.type({
  id: t.number,
  requester: zendeskRequester,
});

export type ZendeskTicket = t.TypeOf<typeof zendeskTicket>;
